/*
 * The gate between the HTML's boot loader and the app. On the dashboard's address the HTML starts the loading animation in a worker before anything else (public/index.html), but a worker
 * cannot start while the main thread is busy, and the app's own code is the busiest thing on the page: once the bundle is in the browser's cache it runs the moment the page has been parsed,
 * and the worker (created a few milliseconds earlier) is then starved for the whole of that run. Measured 2026-10-17 at 4x slower CPU, on a return visit: created at 24ms, first picture at
 * 1,270ms - an empty overlay for 1.2s. So the app does not run until the worker has drawn its first picture (or a short limit has passed - a broken worker must never keep the app from
 * starting). On a first visit the download has already given the worker its time, so the gate is open before the bundle arrives and costs nothing.
 */
export const BOOT_GATE_MAX_MS = 400;

interface BootLoader {
  /** calls back once the boot loader's worker has drawn its first picture (at once if it already has) */
  whenDrawing: (callback: () => void) => void;
}

export const runWhenBootLoaderIsDrawing = (start: () => void, maxMs: number = BOOT_GATE_MAX_MS): void => {
  const boot = (window as unknown as { __bootLoader?: BootLoader }).__bootLoader;
  if (!boot || typeof boot.whenDrawing !== "function") {
    start();

    return;
  }
  let started = false;
  const go = () => {
    if (started) return;
    started = true;
    window.clearTimeout(timer);
    start();
  };
  const timer = window.setTimeout(go, maxMs);
  boot.whenDrawing(go);
};
